// Item 101 — apply an AI style proposal to widgets / canvas *without* touching data bindings.
// Used for the live preview and for the committed Apply, so what you preview is exactly what you get.

export function themeWidgetPatch(p) {
  if (!p) return {};
  const patch = { ...(p.widget_patch || {}) };
  if (p.palette && !patch.palette) patch.palette = p.palette;
  if (p.colors && p.colors.length && !patch.colors) patch.colors = p.colors;
  return patch;
}

const mergeOptions = (opts, patch) => {
  const { appearance, titleStyle, ...flat } = patch;
  const next = { ...opts, ...flat };
  if (appearance) next.appearance = { ...(opts.appearance || {}), ...appearance };
  if (titleStyle) next.titleStyle = { ...(opts.titleStyle || {}), ...titleStyle };
  return next;
};

export function themedWidgets(widgets, p) {
  const patch = themeWidgetPatch(p);
  if (!p || !Object.keys(patch).length) return widgets;
  const only = p.scope === "widget" ? p.widget_id : null;
  return (widgets || []).map((w) => {
    if (only && w.id !== only) return w;
    if (!only && ["slicer", "iframe"].includes(w.type)) return w;
    return { ...w, config: { ...(w.config || {}), options: mergeOptions((w.config || {}).options || {}, patch) } };
  });
}

export function themedCanvas(canvas, p) {
  if (!p || p.scope === "widget") return canvas;
  const c = { ...(p.canvas_patch || {}) };
  delete c.colors;
  if (!Object.keys(c).length) return canvas;
  return { ...canvas, ...c };
}

export function describeTheme(p) {
  if (!p) return "";
  const bits = [];
  if (p.palette) bits.push(`palette “${p.palette}”`);
  if (p.colors?.length) bits.push(`${p.colors.length} chart colours`);
  const cp = Object.keys(p.canvas_patch || {}).filter((k) => k !== "colors");
  if (cp.length) bits.push(`canvas: ${cp.join(", ")}`);
  const wp = p.widget_patch || {};
  const card = Object.keys(wp.appearance || {});
  const title = Object.keys(wp.titleStyle || {});
  if (card.length) bits.push(`card: ${card.join(", ")}`);
  if (title.length) bits.push(`title: ${title.join(", ")}`);
  return bits.join(" · ");
}
